module.exports = __webpack_public_path__ + "static/media/studio-slide10.96fa7aba.png";